// extracted by mini-css-extract-plugin
export const arrow = "bottom-nav-module--arrow--3ENn0";
export const lightblue = "bottom-nav-module--lightblue--1YcOo";
export const pink = "bottom-nav-module--pink--2yw1m";
export const blue = "bottom-nav-module--blue--1c6fG";
export const orange = "bottom-nav-module--orange--SdSYS";
export const green = "bottom-nav-module--green--1FZX8";
export const yellow = "bottom-nav-module--yellow--2a0E2";
export const navLink = "bottom-nav-module--nav--link--3IadH";
export const prevLink = "bottom-nav-module--prev-link--2NwYK";
export const nextLink = "bottom-nav-module--next-link--1mCqJ";
export const footerRight = "bottom-nav-module--footer--right--m2B45";
export const borderTop = "bottom-nav-module--border--top--18JRi";
export const footer = "bottom-nav-module--footer--cENxd";
export const logoWrap = "bottom-nav-module--logo--wrap--1wbHf";
export const pjmPosition = "bottom-nav-module--pjm--position--3WeJB";
export const linkWrap = "bottom-nav-module--linkWrap--17u6i";
export const addressLink = "bottom-nav-module--addressLink--3E7X-";